import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Layout from "../../../../Layout/Layout";
import OrdersColumnChart from "./../../Charts/OrdersColumnChart";
import PieChart from "./../../Charts/PieChart";
import DonutChart from "./../../Charts/DonutChart";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Serivce
// import ItemService from "../../services/supplier_appCommonService";
import customerItemService from "../../../../services/customer_appCommonService";
import supplierItemService from "../../../../services/supplier_appCommonService";
import LoaderSmall from "../../../../Components/LoaderSmall";

import {
  formatToTwoDigits,
  getCurrentDate,
} from "../../../../common/Validations";
import {setEquipmentRentFormFilters } from "../../../../redux/feature/customer_app/customerSlice";
import DatePickerComponent from "./../../Charts/FilterComponent/DatePickerComponent";
import CustomerConstants from "../../../../common/CustomerConstants";

const CustomerV5Dashboard = () => {
  localStorage.setItem("menu", "Dashboard");
  localStorage.setItem("submenu", "-");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isUserDataLoaded, setIsUserDataLoaded] = useState(false);

  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  useEffect(() => {
    if (userData && userData.userId) {
      setIsUserDataLoaded(true);
    }
  }, [userData]);
  const navigateToMainPage = (page) => {
    if (page === "totalOrderCount") {
      navigate(CustomerConstants.CUSTOMER_V5_PURCHASE_ORDER_LIST);
    } else if (page === "totalServicePurchaseOrderCount") {
      navigate(
        CustomerConstants.CUSTOMER_V5_MR_POCOLLABRATION_SERVICE_PURCHASE_ORDER_LIST,
      );
    } else if (page === "grnList") {
      navigate(
        CustomerConstants.CUSTOMER_V5_MR_POCOLLABRATION_GOODS_RECEIVED_NOTE,
      );
    } else if (page === "qualityCheckList") {
      navigate(CustomerConstants.CUSTOMER_V5_QUALITY_CHECK_LIST_MR);
    } else if (page === "serviceEneryList") {
      navigate(
        CustomerConstants.CUSTOMER_V5_MR_POCOLLABRATION_SERVICE_ENTRY_SHEET_LIST,
      );
    } else if (page === "totalSupplierCount") {
      navigate(CustomerConstants.SUPPILER_LIST_MR);
    } else if (page === "material") {
      navigate(CustomerConstants.CUSTOMER_V5_MR_MATERIAL_LIST);
    } else if (page === "salesBarcodeList") {
      navigate(CustomerConstants.CUSTOMER_V5_MR_MATERIAL_BARCODE_SALE_LIST);
    } else if (page === "rentBarcodeList") {
      navigate(CustomerConstants.CUSTOMER_V5_MR_MATERIAL_BARCODE_RENT_LIST);
    } else if (page === "salseAndRentErfList") {
      navigate(CustomerConstants.CUSTOMER_V5_MR_ERF_LIST);
    } else if (page === "totalCompanyCount") {
      navigate(CustomerConstants.CUSTOMER_V5_COMPANY_LIST_MR);
    } else if (page === "mrUserList") {
      navigate(CustomerConstants.CUSTOMER_V5_MR_USER_LIST);
    } else if (page === "salesStockIn") {
      navigate(CustomerConstants.CUSTOMER_V5_MR_MATERIAL_BARCODE_SALE_LIST);
    } else if (page === "extendedErfList") {
      navigate(CustomerConstants.CUSTOMER_V5_MR_EXTENSION_ERF_LIST);
    } else if (page === "totalErfAssignStoreCount") {
      navigate(CustomerConstants.CUSTOMER_V5_MR_STORE_ERF_LIST);
    } else if (page === "dispatchList") {
      navigate(CustomerConstants.CUSTOMER_V5_MR_DISPATCH_ERF_LIST);
    } else if (page === "erfList") {
      navigate(CustomerConstants.CUSTOMER_V5_MR_ERF_LIST);
      
    } else if (page === "erfReadytoDispatch") {
      navigate(CustomerConstants.CUSTOMER_V5_MR_DISPATCH_ERF_LIST);
    } else if (page === "erfUnderServiceExecutive") {
      navigate(CustomerConstants.CUSTOMER_V5_MR_SERVICE_PROVIDE_ERF_LIST);
    }
  };

  const navigateWithFilters = (filters, page = "erfList") => {
    dispatch(setEquipmentRentFormFilters(filters));
    navigateToMainPage(page);
  };

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = String(today.getMonth() + 1).padStart(2, "0");

  const [filterShow, setFilterShow] = useState(false);

  const [totalUserCount, setTotalUserCount] = useState("");
  const [totalUserCountExtension, setTotalUserCountExtension] = useState("");
  const [totalUserCountStatus, setTotalUserCountStatus] = useState(false);

  const [totalOrderCount, setTotalOrderCount] = useState("");
  const [totalOrderCountStatus, setTotalOrderStatus] = useState(false);

  const [totalRTDERFCount, setTotalRTDERFCount] = useState("");
  const [totalRTDERFCountStatus, setTotalRTDERFStatus] = useState(false);

  const [totalErfUseCount, setTotalErfUseCount] = useState("");
  const [totalErfUseCountStatus, setTotalErfUseStatus] = useState(false);

  const [totalErRefundAmount, setTotalErRefundAmount] = useState("");
  const [totalErRefundAmountStatus, setTotalErRefundAmountStatus] =
    useState(false);

  const [totalErRefundAmountPending, setTotalErRefundAmountPending] =
    useState("");
  const [
    totalErRefundAmountStatusPending,
    setTotalErRefundAmountStatusPending,
  ] = useState(false);

  const [totalErfTallyStatusDone, setTotalErfTallyStatusDone] = useState("");
  const [totalErfTallyStatusDoneStatus, setTotalErfTallyStatusDoneStatus] =
    useState(false);

  const [totalErfTallyStatusPending, setTotalErfTallyStatusPending] =
    useState("");
  const [
    totalErfTallyStatusPendingStatus,
    setTotalErfTallyStatusPendingStatus,
  ] = useState(false);

  const [totalErfCreditNoteDone, setTotalErfCreditNoteDone] = useState("");
  const [totalErfCreditNoteDoneStatus, setTotalErfCreditNoteDoneStatus] =
    useState(false);

  const [totalErfCreditNotePending, setTotalErfCreditNotePending] =
    useState("");
  const [totalErfCreditNotePendingStatus, setTotalErfCreditNotePendingStatus] =
    useState(false);

  const [totalErFinanceConfirmed, setTotalErFinanceConfirmed] = useState("");
  const [totalErFinanceConfirmedStatus, setTotalErFinanceConfirmedStatus] =
    useState(false);

  const [
    totalErfFinanceNotConfirmedStatus,
    setTotalErfFinanceNotConfirmedStatus,
  ] = useState(false);
  const [totalErfFinanceNotConfirmed, setTotalErfFinanceNotConfirmed] =
    useState("");

const [totalErPartialEarlyClosur, setTotalErPartialEarlyClosur] = useState("");
const [totalErPartialEarlyClosurStatus, setTotalErPartialEarlyClosurStatus] = useState(false);

const [totalErEarlyClosur, setTotalErEarlyClosur] = useState("");
const [totalErEarlyClosurStatus, setTotalErEarlyClosurStatus] = useState(false);

const [totalErClosed, setTotalErClosed] = useState("");
const [totalErClosedStatus, setTotalErClosedStatus] = useState(false);

  const [supplierStatusColChart, setSupplierStatusColChart] = useState("");
  const [loadingAdviceColChart, setLoadingAdviceColChart] = useState("");

  const [hideItem, setHideItem] = useState(false);

  const [supplierStatusLoading, setSupplierStatusLoading] = useState(false);
  const [loadingAdviceLoading, setLoadingAdviceLoading] = useState(false);
  // const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [storeDispatchData, setStoreDispatchData] = useState("");
  const [storeDispatchLoading, setStoreDispatchLoading] = useState(false);
  const [pcdData, setPcdData] = useState("");
  const [pcdLoading, setPcdLoading] = useState("");
  const [erfExtensionData, setErfExtensionData] = useState("");
  const [erfExtensionLoading, setErfExtensionLoading] = useState(false);
  const [erfStatusData, setErfStatusData] = useState("");
  const [erfStatusLoading, setErfStatusLoading] = useState(false);

  const [qualityCheckChartData, setQualityCheckChartData] = useState("");
  const [qualityCheckLoading, setQualityCheckLoading] = useState(false); // Using consistent naming
  const [grnchartData, setGrnChartData] = useState("");
  const [grnStatusLoading, setGrnStatusLoading] = useState("");
  const [getServiceEnterySheetStatus, setServiceEnterySheetStatus] = useState();
  const [getTotalServiceEnterySheetCount, setTotalServiceEnterySheetCount] =
    useState();
  // RentBarCodeCount
  const [getRentBarCodeStatus, setRentBarCodeStatus] = useState();
  const [getTotalRentBarCodeCount, setTotalRentBarCodeCount] = useState();
  // SalesBarCodeCount
  const [getSalesBarCodeStatus, setSalesBarCodeStatus] = useState();
  const [getTotalSalesBarCodeCount, setTotalSalesBarCodeCount] = useState();
  // SalesAndRentErfCount
  const [getSalesAndRentErfStatus, setSalesAndRentErfStatus] = useState();
  const [getTotalSalesAndRentErfCount, setTotalSalesAndRentErfCount] =
    useState();
  const [getRentErfStatus, setRentErfStatus] = useState();
  const [getTotalRentErfCount, setTotalRentErfCount] = useState();
  const [getSalesErfStatus, setSalesErfStatus] = useState();
  const [getTotalSalesErfCount, setTotalSalesErfCount] = useState();
  //nursing
  const [getNursingErfStatus, setNursingErfStatus] = useState();
  const [getTotalNursingErfCount, setTotalNursingErfCount] = useState();
  //service
  const [getServiceErfStatus, setServiceErfStatus] = useState();
  const [getTotalServiceErfCount, setTotalServiceErfCount] = useState();
  // SalesErfCount

  // MaterialCount
  const [getMaterialStatus, setMaterialStatus] = useState();
  const [getTotalMaterialCount, setTotalMaterialCount] = useState();
  // MaterialCount
  // material stockin and stock out count
  const [stockInCount, setStockInCount] = useState();
  const [stockOutCount, setStockOutCount] = useState();
  const [salesStockIn, setSalesStockIn] = useState();
  const [salesStockOut, setSalesStockOut] = useState();
  const [rentStockIn, setRentStockIn] = useState();
  const [rentStockOut, setRentStockOut] = useState();
  // QualityCheckCount
  const [getQualityCheckStatus, setQualityCheckStatus] = useState();
  const [getTotalQualityCheckCount, setTotalQualityCheckCount] = useState();
  // QualityCheckCount
  const [getGrnStatus, setGrnStatus] = useState();
  const [getTotalGrnCount, setTotalGrnCount] = useState();
  const [totalCompanyCount, setTotalCompanyCount] = useState("");
  const [totalCompanyCountStatus, setTotalCompanyCountStatus] = useState(false);
  const [totalVendorCount, setTotalVendorCount] = useState("");
  const [totalVendorCountStatus, setTotalVendorCountStatus] = useState(false);
  const [totalErfAssignStoreCount, setTotalErfAssignStoreCount] = useState("");
  const [totalErfAssignStoreStatus, setTotalErfAssignStoreStatus] =
    useState(false);
  const [totalDispatchCount, setTotalDispatchCount] = useState("");
  const [totalDispatchStatus, setTotalDispatchStatus] = useState("");
  // eslint-disable-next-line
  const [getUser, setUser] = useState();
  const [getUserRole, setUserRole] = useState();

  // const loadDispatchCount = async () => {
  //   setTotalDispatchStatus(true);

  //   let obj = {
  //     queryName: "ERFList",
  //     page: 1,
  //     rowFilter: {
  //       erfStatusCode: "DPD",
  //     },
  //   };

  //   await supplierItemService.generateQuery(obj).then((item) => {
  //     if (item?.status === 200) {
  //       setTotalDispatchCount(item?.total);
  //     } else {
  //       toast.error(item?.message || "Please try again for Dispatch Count", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });

  //   setTotalDispatchStatus(false);
  // };

  // const loadErfAssignStoreCount = async () => {
  //   setTotalErfAssignStoreStatus(true);

  //   let obj = {
  //     queryName: "ERFList",
  //     page: 1,
  //     per_page: 10,
  //     searchTerm: "",
  //     timeZone: "Asia/Calcutta",
  //     rowFilter: {
  //       erfStatus: "Assign To Store",
  //     },
  //   };

  //   await supplierItemService.generateQuery(obj).then((item) => {
  //     if (item?.status === 200) {
  //       setTotalErfAssignStoreCount(item?.total);
  //     } else {
  //       toast.error(
  //         item?.message || "Please try again for ERF Assign Store Count",
  //         {
  //           duration: 4000,
  //           position: "top-right",
  //         },
  //       );
  //     }
  //   });

  //   setTotalErfAssignStoreStatus(false);
  // };
  const loadDispatchCount = async () => {
    setTotalDispatchStatus(true);

    const allowedRoles = ["SALES-PCD", "SALES-OFFICER"];

    const hasSalesRoles = getUserRole?.some((r) =>
      allowedRoles.includes(r.roleId),
    );

    let andConditions = [
      {
        erfStatusCode: "DPD",
      },
    ];

    // 👉 Add createdBy dynamically based on role
    if (hasSalesRoles) {
      andConditions.push({
        createdBy: getUser,
      });
    }

    let obj = {
      queryName: "ERFList",
      page: 1,
      rowFilter: {
        $and: andConditions,
      },
    };

    await supplierItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalDispatchCount(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Dispatch Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setTotalDispatchStatus(false);
  };
  const loadErfAssignStoreCount = async () => {
    setTotalErfAssignStoreStatus(true);

    const allowedRoles = ["SALES-PCD", "SALES-OFFICER"];

    const hasSalesRoles = getUserRole?.some((r) =>
      allowedRoles.includes(r.roleId),
    );

    let andConditions = [
      {
        erfStatus: "Assign To Store",
      },
    ];

    // 👉 Add createdBy dynamically
    if (hasSalesRoles) {
      andConditions.push({
        createdBy: getUser, // ✅ dynamic user
      });
    }

    let obj = {
      queryName: "ERFList",
      page: 1,
      per_page: 10,
      searchTerm: "",
      timeZone: "Asia/Calcutta",
      rowFilter: {
        $and: andConditions,
      },
    };

    await supplierItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalErfAssignStoreCount(item?.total);
      } else {
        toast.error(
          item?.message || "Please try again for ERF Assign Store Count",
          {
            duration: 4000,
            position: "top-right",
          },
        );
      }
    });

    setTotalErfAssignStoreStatus(false);
  };
  const loadVendorCount = async () => {
    setTotalVendorCountStatus(true);

    let obj = {
      queryName: "getSupplierList",
      rowFilter: {
        $and: [
          {
            "vendorCategory.vendorCategoryCode": {
              $in: ["V04", "V11", "V12", "V13", "V14"],
            },
          },
        ],
      },
      page: 1,
      per_page: 10,
      searchTerm: "",
      timeZone: "Asia/Calcutta",
    };

    await supplierItemService.getSupplierList(obj).then((item) => {
      if (item?.status === 200) {
        setTotalVendorCount(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Vendor Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setTotalVendorCountStatus(false);
  };
  const loadCompanyCount = async () => {
    setTotalCompanyCountStatus(true);

    let obj = {
      page: 1,
      // per_page: ,
      queryName: "Get_CompanyMaster_List",
      searchTerm: "",
      timeZone: "Asia/Calcutta",
    };

    await supplierItemService.generateCustomerQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalCompanyCount(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Company Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setTotalCompanyCountStatus(false);
  };

  // loadOrderCount
  const loadOrderCount = async () => {
    setTotalOrderStatus(true);
    // let obj = {
    //   queryName: "totalOrderBookingCount",
    // };
    let obj = {
      module: "PO",
      queryName: "getMaterialPO",
      page: 1,
      per_page: 10,
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalOrderCount(item?.total);

        // loadOrderCompletedCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalOrderStatus(false);
  };

  // rtdErfCount
  // const rtdErfCount = async () => {
  //   setTotalRTDERFStatus(true);

  //   let obj = {
  //     queryName: "RTDERF",
  //     page: 1,
  //     per_page: 10,
  //   };
  //   await customerItemService.generateQuery(obj).then((item) => {
  //     if (item?.status === 200) {
  //       setTotalRTDERFCount(item?.total);

  //       // loadOrderCompletedCount(item.data);
  //     } else {
  //       toast.error(item?.message || "Please try again for Total PO Count", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });
  //   setTotalRTDERFStatus(false);
  // };
  const rtdErfCount = async () => {
    setTotalRTDERFStatus(true);

    const allowedRoles = ["SALES-PCD", "SALES-OFFICER"];

    const hasSalesRoles = getUserRole?.some((r) =>
      allowedRoles.includes(r.roleId),
    );

    let obj = {
      queryName: "RTDERF",
      page: 1,
      per_page: 10,
    };

    // 👉 Add rowFilter ONLY if role matches
    if (hasSalesRoles) {
      obj.rowFilter = {
        $and: [
          {
            createdBy: getUser,
          },
        ],
      };
    }

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalRTDERFCount(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setTotalRTDERFStatus(false);
  };

  // erfUseCount
  // const erfUseCount = async () => {
  //   setTotalErfUseStatus(true);

  //   let obj = {
  //     queryName: "ERFList",
  //     page: 1,
  //     per_page: 10,
  //     rowFilter: {
  //       erfStatusCode: "USE",
  //     },
  //   };
  //   await customerItemService.generateQuery(obj).then((item) => {
  //     if (item?.status === 200) {
  //       setTotalErfUseCount(item?.total);

  //       // loadOrderCompletedCount(item.data);
  //     } else {
  //       toast.error(item?.message || "Please try again for Total PO Count", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });
  //   setTotalErfUseStatus(false);
  // };
  const erfUseCount = async () => {
    setTotalErfUseStatus(true);

    const allowedRoles = ["SALES-PCD", "SALES-OFFICER"];

    const hasSalesRoles = getUserRole?.some((r) =>
      allowedRoles.includes(r.roleId),
    );

    let andConditions = [
      {
        erfStatusCode: "USE",
      },
    ];

    // 👉 Apply role-based filter
    if (hasSalesRoles) {
      andConditions.push({
        createdBy: getUser,
      });
    }

    let obj = {
      queryName: "ERFList",
      page: 1,
      per_page: 10,
      rowFilter: {
        $and: andConditions,
      },
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalErfUseCount(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setTotalErfUseStatus(false);
  };

  const erfRefundAmountDone = async () => {
    setTotalErRefundAmountStatus(true);

    const allowedRoles = ["SALES-PCD", "SALES-OFFICER"];

    const hasSalesRoles = getUserRole?.some((r) =>
      allowedRoles.includes(r.roleId),
    );

    let andConditions = [
      {
        erfStatusCode: "USE",
      },
    ];

    // 👉 Apply role-based filter
    if (hasSalesRoles) {
      andConditions.push({
        createdBy: getUser,
      });
    }

    let obj = {
      queryName: "ERFList",
      page: 1,
      per_page: 100,
      rowFilter: {
        $and: [
          {
            refundAmountIndicator: false,
          },
        ],
      },
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalErRefundAmount(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setTotalErRefundAmountStatus(false);
  };

  const erfRefundAmountPending = async () => {
    setTotalErRefundAmountStatusPending(true);

    const allowedRoles = ["SALES-PCD", "SALES-OFFICER"];

    const hasSalesRoles = getUserRole?.some((r) =>
      allowedRoles.includes(r.roleId),
    );

    let andConditions = [
      {
        erfStatusCode: "USE",
      },
    ];

    // 👉 Apply role-based filter
    if (hasSalesRoles) {
      andConditions.push({
        createdBy: getUser,
      });
    }

    let obj = {
      queryName: "ERFList",
      page: 1,
      per_page: 100,
      rowFilter: {
        $and: [
          {
            refundAmountIndicator: true,
          },
        ],
      },
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalErRefundAmountPending(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setTotalErRefundAmountStatusPending(false);
  };

  const erfTallyStatusDone = async () => {
    setTotalErfTallyStatusDoneStatus(true);

    const allowedRoles = ["SALES-PCD", "SALES-OFFICER"];

    const hasSalesRoles = getUserRole?.some((r) =>
      allowedRoles.includes(r.roleId),
    );

    let andConditions = [
      {
        erfStatusCode: "USE",
      },
    ];

    // 👉 Apply role-based filter
    if (hasSalesRoles) {
      andConditions.push({
        createdBy: getUser,
      });
    }

    let obj = {
      queryName: "ERFList",
      page: 1,
      per_page: 100,
      searchTerm: "",
      timeZone: "Asia/Calcutta",
      rowFilter: {
        $and: [
          {
            tallyStatusIndicator: {
              $regex: ".*Done.*",
              $options: "i",
            },
          },
        ],
      },
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalErfTallyStatusDone(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setTotalErfTallyStatusDoneStatus(false);
  };

  const erfTallyStatusPending = async () => {
    setTotalErfTallyStatusPendingStatus(true);

    const allowedRoles = ["SALES-PCD", "SALES-OFFICER"];

    const hasSalesRoles = getUserRole?.some((r) =>
      allowedRoles.includes(r.roleId),
    );

    let andConditions = [
      {
        erfStatusCode: "USE",
      },
    ];

    // 👉 Apply role-based filter
    if (hasSalesRoles) {
      andConditions.push({
        createdBy: getUser,
      });
    }

    let obj = {
      queryName: "ERFList",
      page: 1,
      per_page: 100,
      searchTerm: "",
      timeZone: "Asia/Calcutta",
      rowFilter: {
        $and: [
          {
            tallyStatusIndicator: {
              $regex: ".*Pending.*",
              $options: "i",
            },
          },
        ],
      },
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalErfTallyStatusPending(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setTotalErfTallyStatusPendingStatus(false);
  };

  const erfCreditNotePending = async () => {
    setTotalErfCreditNotePendingStatus(true);

    const allowedRoles = ["SALES-PCD", "SALES-OFFICER"];

    const hasSalesRoles = getUserRole?.some((r) =>
      allowedRoles.includes(r.roleId),
    );

    let andConditions = [
      {
        erfStatusCode: "USE",
      },
    ];

    // 👉 Apply role-based filter
    if (hasSalesRoles) {
      andConditions.push({
        createdBy: getUser,
      });
    }

    let obj = {
      queryName: "ERFList",
      page: 1,
      per_page: 100,

      rowFilter: {
        $and: [
          {
            creditNoteIndicator: true,
          },
        ],
      },
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalErfCreditNotePending(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setTotalErfCreditNotePendingStatus(false);
  };

  const erfCreditNoteDone = async () => {
    setTotalErfCreditNoteDoneStatus(true);

    const allowedRoles = ["SALES-PCD", "SALES-OFFICER"];

    const hasSalesRoles = getUserRole?.some((r) =>
      allowedRoles.includes(r.roleId),
    );

    let andConditions = [
      {
        erfStatusCode: "USE",
      },
    ];

    // 👉 Apply role-based filter
    if (hasSalesRoles) {
      andConditions.push({
        createdBy: getUser,
      });
    }

    let obj = {
      queryName: "ERFList",
      page: 1,
      per_page: 100,

      rowFilter: {
        $and: [
          {
            creditNoteIndicator: false,
          },
        ],
      },
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalErfCreditNoteDone(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setTotalErfCreditNoteDoneStatus(false);
  };

  const erfFinanceConfiremd = async () => {
    setTotalErFinanceConfirmedStatus(true);

    const allowedRoles = ["SALES-PCD", "SALES-OFFICER"];

    const hasSalesRoles = getUserRole?.some((r) =>
      allowedRoles.includes(r.roleId),
    );

    let andConditions = [
      {
        erfStatusCode: "USE",
      },
    ];

    // 👉 Apply role-based filter
    if (hasSalesRoles) {
      andConditions.push({
        createdBy: getUser,
      });
    }

    let obj = {
      queryName: "ERFList",
      page: 1,
      per_page: 100,
      rowFilter: {
        $and: [
          {
            financeCollectionConfirmation: {
              $regex: ".*Confirmed.*",
              $options: "i",
            },
          },
        ],
      },
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalErFinanceConfirmed(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setTotalErFinanceConfirmedStatus(false);
  };
    const erfFinanceNotConfiremd = async () => {
    setTotalErfFinanceNotConfirmedStatus(true);

    const allowedRoles = ["SALES-PCD", "SALES-OFFICER"];

    const hasSalesRoles = getUserRole?.some((r) =>
      allowedRoles.includes(r.roleId),
    );

    let andConditions = [
      {
        erfStatusCode: "USE",
      },
    ];

    // 👉 Apply role-based filter
    if (hasSalesRoles) {
      andConditions.push({
        createdBy: getUser,
      });
    }

    let obj = {
      queryName: "ERFList",
      page: 1,
      per_page: 100,
      rowFilter: {
        $and: [
          {
            financeCollectionConfirmation: {
              $regex: ".*Not Confirmed.*",
              $options: "i",
            },
          },
        ],
      },
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalErfFinanceNotConfirmed(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setTotalErfFinanceNotConfirmedStatus(false);
  };
    const erfPartialEarlyClousr = async () => {
    setTotalErPartialEarlyClosurStatus(true);

    const allowedRoles = ["SALES-PCD", "SALES-OFFICER"];

    const hasSalesRoles = getUserRole?.some((r) =>
      allowedRoles.includes(r.roleId),
    );

    let andConditions = [
      {
        erfStatusCode: "USE",
      },
    ];

    // 👉 Apply role-based filter
    if (hasSalesRoles) {
      andConditions.push({
        createdBy: getUser,
      });
    }

    let obj = {
      queryName: "ERFList",
      page: 1,
      per_page: 100,
      rowFilter: {
        $and: [
            {
                pcCallStatus: {
                    $regex: ".*Partial Early Closur.*",
                    $options: "i"
                }
            },
        ],
      },
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalErPartialEarlyClosur(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setTotalErPartialEarlyClosurStatus(false);
  };
   const erfEarlyClousr = async () => {
    setTotalErEarlyClosurStatus(true);

    const allowedRoles = ["SALES-PCD", "SALES-OFFICER"];

    const hasSalesRoles = getUserRole?.some((r) =>
      allowedRoles.includes(r.roleId),
    );

    let andConditions = [
      {
        erfStatusCode: "USE",
      },
    ];

    // 👉 Apply role-based filter
    if (hasSalesRoles) {
      andConditions.push({
        createdBy: getUser,
      });
    }

    let obj = {
      queryName: "ERFList",
      page: 1,
      per_page: 100,
      rowFilter: {
        $and: [
            {
                pcCallStatus: {
                    $regex: ".*Early Closure.*",
                    $options: "i"
                }
            },
        ],
      },
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalErEarlyClosur(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setTotalErEarlyClosurStatus(false);
  };
  const erfClosed = async () => {
    setTotalErClosedStatus(true);

    const allowedRoles = ["SALES-PCD", "SALES-OFFICER"];

    const hasSalesRoles = getUserRole?.some((r) =>
      allowedRoles.includes(r.roleId),
    );

    let andConditions = [
      {
        erfStatusCode: "USE",
      },
    ];

    // 👉 Apply role-based filter
    if (hasSalesRoles) {
      andConditions.push({
        createdBy: getUser,
      });
    }

    let obj = {
      queryName: "ERFList",
      page: 1,
      per_page: 100,
      rowFilter: {
        $and: [
            {
                pcCallStatus: {
                    $regex: ".*Closed.*",
                    $options: "i"
                }
            },
        ],
      },
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalErClosed(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setTotalErClosedStatus(false);
  };
  // servicesPurchaseOrderCount
  const [
    getTotalServicesPurchaseOrderStatus,
    setTotalServicesPurchaseOrderStatus,
  ] = useState();
  const [
    getTotalServicesPurchaseOrderCount,
    setTotalServicesPurchaseOrderCount,
  ] = useState();
  // servicesPurchaseOrderCount
  const servicesPurchaseOrderCount = async () => {
    setTotalServicesPurchaseOrderStatus(true);

    let obj = {
      module: "PO",
      queryName: "getServicePO",
      page: 1,
      per_page: 10,
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalServicesPurchaseOrderCount(item?.total);

        // loadOrderCompletedCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalServicesPurchaseOrderStatus(false);
  };
  // GRNCount

  const grnCount = async () => {
    setGrnStatus(true);

    let obj = {
      module: "",
      queryName: "",
      page: 1,
      per_page: 10,
    };

    await supplierItemService.getGoodsReceivedNote(obj).then((item) => {
      if (item?.status === 200) {
        setTotalGrnCount(item?.total);

        // loadOrderCompletedCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setGrnStatus(false);
  };

  const qualityCheckCount = async () => {
    setQualityCheckStatus(true);

    let obj = {
      queryName: "getQualityCheckList",
      page: 1,
      per_page: 10,
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalQualityCheckCount(item?.total);

        // loadOrderCompletedCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setQualityCheckStatus(false);
  };

  const materialCountStockInStockOut = async () => {
    setMaterialStatus(true);

    try {
      const saleObj = {
        queryName: "MaterilBarcodeListSL",
        page: 1,
        per_page: 999,
        timeZone: "Asia/Calcutta",
      };

      const rentObj = {
        queryName: "MaterilBarcodeListRE",
        page: 1,
        per_page: 999,
        searchTerm: "",
        timeZone: "Asia/Calcutta",
      };

      const [saleRes, rentRes] = await Promise.all([
        customerItemService.generateQuery(saleObj),
        customerItemService.generateQuery(rentObj),
      ]);

      let totalStockIn = 0;
      let totalStockOut = 0;

      // Sales data
      if (saleRes?.status === 200 && saleRes?.data) {
        saleRes.data.forEach((item) => {
          if (item.materialStatus === "StockIn") {
            totalStockIn += 1;
          }
          if (item.materialStatus === "StockOut") {
            totalStockOut += 1;
          }
        });
      }

      // Rent data
      if (rentRes?.status === 200 && rentRes?.data) {
        rentRes.data.forEach((item) => {
          if (item.materialStatus === "StockIn") {
            totalStockIn += 1;
          }
          if (item.materialStatus === "StockOut") {
            totalStockOut += 1;
          }
        });
      }

      setStockInCount(totalStockIn);
      setStockOutCount(totalStockOut);
    } catch (error) {
      toast.error("Failed to fetch material counts");
    }

    setMaterialStatus(false);
  };
  // const [materialStatus, setMaterialStatus] = useState(false);
  const materialCount = async () => {
    setMaterialStatus(true);

    let obj = {
      queryName: "getMaterilMasterList",
      page: 1,
      per_page: 10,
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalMaterialCount(item?.total);

        // loadOrderCompletedCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setMaterialStatus(false);
  };

  const salesandRentStocinStockOut = async () => {
    setMaterialStatus(true);

    try {
      const salesObj = {
        queryName: "MaterilBarcodeListSL",
        page: 1,
        per_page: 1000,
        timeZone: "Asia/Calcutta",
      };

      const rentObj = {
        queryName: "MaterilBarcodeListRE",
        page: 1,
        per_page: 1000,
        searchTerm: "",
        timeZone: "Asia/Calcutta",
      };

      const [salesRes, rentRes] = await Promise.all([
        customerItemService.generateQuery(salesObj),
        customerItemService.generateQuery(rentObj),
      ]);

      let salesIn = 0;
      let salesOut = 0;
      let rentIn = 0;
      let rentOut = 0;

      // SALES
      if (salesRes?.status === 200 && salesRes?.data) {
        salesRes.data.forEach((item) => {
          if (item.materialStatus === "StockIn") {
            salesIn++;
          }

          if (item.materialStatus === "StockOut") {
            salesOut++;
          }
        });
      }

      // RENT
      if (rentRes?.status === 200 && rentRes?.data) {
        rentRes.data.forEach((item) => {
          if (item.materialStatus === "StockIn") {
            rentIn++;
          }

          if (item.materialStatus === "StockOut") {
            rentOut++;
          }
        });
      }

      setSalesStockIn(salesIn);
      setSalesStockOut(salesOut);
      setRentStockIn(rentIn);
      setRentStockOut(rentOut);
    } catch (error) {
      toast.error("Failed to fetch material count");
    }

    setMaterialStatus(false);
  };

  // SalesErfCount

  // const nursingErfCount = async () => {
  //   setNursingErfStatus(true);

  //   let obj = {
  //     queryName: "ERFList",
  //     page: 1,
  //     per_page: 10,
  //     rowFilter: {
  //       $and: [
  //         {
  //           erfType: "Nursing Service",
  //         },
  //       ],
  //     },
  //   };

  //   await customerItemService.generateQuery(obj).then((item) => {
  //     if (item?.status === 200) {
  //       setTotalNursingErfCount(item?.total);

  //       // loadOrderCompletedCount(item.data);
  //     } else {
  //       toast.error(item?.message || "Please try again for Total PO Count", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });
  //   setNursingErfStatus(false);
  // };
  const nursingErfCount = async () => {
    setNursingErfStatus(true);

    const allowedRoles = ["SALES-PCD", "SALES-OFFICER"];

    const hasSalesRoles = getUserRole?.some((r) =>
      allowedRoles.includes(r.roleId),
    );

    let andConditions = [
      {
        erfType: "Nursing Service",
      },
    ];

    // Add condition ONLY if role matches
    if (hasSalesRoles) {
      andConditions.push({
        createdBy: getUser,
      });
    }

    let obj = {
      queryName: "ERFList",
      page: 1,
      per_page: 10,
      rowFilter: {
        $and: andConditions,
      },
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalNursingErfCount(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setNursingErfStatus(false);
  };

  //service erf
  // const serviceErfCount = async () => {
  //   setServiceErfStatus(true);

  //   let obj = {
  //     queryName: "ERFList",
  //     page: 1,
  //     per_page: 10,
  //     rowFilter: {
  //       $and: [
  //         {
  //           erfType: "Service",
  //         },
  //       ],
  //     },
  //   };

  //   await customerItemService.generateQuery(obj).then((item) => {
  //     if (item?.status === 200) {
  //       setTotalServiceErfCount(item?.total);

  //       // loadOrderCompletedCount(item.data);
  //     } else {
  //       toast.error(item?.message || "Please try again for Total PO Count", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });
  //   setServiceErfStatus(false);
  // };
  const serviceErfCount = async () => {
    setServiceErfStatus(true);

    const allowedRoles = ["SALES-PCD", "SALES-OFFICER"];

    const hasSalesRoles = getUserRole?.some((r) =>
      allowedRoles.includes(r.roleId),
    );

    let andConditions = [
      {
        erfType: "Service",
      },
    ];

    // 👉 Add condition ONLY if role matches
    if (hasSalesRoles) {
      andConditions.push({
        createdBy: getUser,
      });
    }

    let obj = {
      queryName: "ERFList",
      page: 1,
      per_page: 10,
      rowFilter: {
        $and: andConditions,
      },
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalServiceErfCount(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setServiceErfStatus(false);
  };

  //Sales erf
  // const salesErfCount = async () => {
  //   setSalesErfStatus(true);

  //   let obj = {
  //     queryName: "ERFList",
  //     page: 1,
  //     per_page: 10,
  //     rowFilter: {
  //       $and: [
  //         {
  //           erfTypeCode: "NR",
  //         },
  //       ],
  //     },
  //   };

  //   await customerItemService.generateQuery(obj).then((item) => {
  //     if (item?.status === 200) {
  //       setTotalSalesErfCount(item?.total);

  //       // loadOrderCompletedCount(item.data);
  //     } else {
  //       toast.error(item?.message || "Please try again for Total PO Count", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });
  //   setSalesErfStatus(false);
  // };
  const salesErfCount = async () => {
    setSalesErfStatus(true);

    const allowedRoles = ["SALES-PCD", "SALES-OFFICER"];
    const hasSalesRoles = getUserRole?.some((r) =>
      allowedRoles.includes(r.roleId),
    );

    let andConditions = [
      {
        erfType: "Sale",
      },
    ];

    if (hasSalesRoles) {
      andConditions.push({
        createdBy: getUser,
      });
    }

    let obj = {
      queryName: "ERFList",
      page: 1,
      per_page: 10,
      rowFilter: {
        $and: andConditions,
      },
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalSalesErfCount(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Sales ERF Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setSalesErfStatus(false);
  };

  // RentErfCount
  // const rentErfCount = async () => {
  //   setRentErfStatus(true);

  //   let obj = {
  //     queryName: "ERFList",
  //     page: 1,
  //     per_page: 10,
  //     rowFilter: {
  //       $and: [
  //         {
  //           erfType: "Rent",
  //         },
  //       ],
  //     },
  //   };

  //   await customerItemService.generateQuery(obj).then((item) => {
  //     if (item?.status === 200) {
  //       setTotalRentErfCount(item?.total);

  //       // loadOrderCompletedCount(item.data);
  //     } else {
  //       toast.error(item?.message || "Please try again for Total PO Count", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });
  //   setRentErfStatus(false);
  // };
  const rentErfCount = async () => {
    setRentErfStatus(true);

    const allowedRoles = ["SALES-PCD", "SALES-OFFICER"];
    const hasSalesRoles = getUserRole?.some((r) =>
      allowedRoles.includes(r.roleId),
    );

    let andConditions = [
      {
        erfType: "Rent",
      },
    ];

    if (hasSalesRoles) {
      andConditions.push({
        createdBy: getUser,
      });
    }

    let obj = {
      queryName: "ERFList",
      page: 1,
      per_page: 10,
      rowFilter: {
        $and: andConditions,
      },
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalRentErfCount(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Rent ERF Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setRentErfStatus(false);
  };

  // SalesAndRentErfCount
  // const salesAndrentErfCount = async () => {
  //   setSalesAndRentErfStatus(true);

  //   let obj = {
  //     queryName: "ERFList",
  //     page: 1,
  //     per_page: 10,
  //   };

  //   await customerItemService.generateQuery(obj).then((item) => {
  //     if (item?.status === 200) {
  //       setTotalSalesAndRentErfCount(item?.total);

  //       // loadOrderCompletedCount(item.data);
  //     } else {
  //       toast.error(item?.message || "Please try again for Total PO Count", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });
  //   setSalesAndRentErfStatus(false);
  // };
  const salesAndrentErfCount = async () => {
    setSalesAndRentErfStatus(true);

    const allowedRoles = ["SALES-PCD", "SALES-OFFICER"];

    const hasSalesRoles = getUserRole?.some((r) =>
      allowedRoles.includes(r.roleId),
    );

    let obj = {
      queryName: "ERFList",
      page: 1,
      per_page: 10,
    };

    // 👉 Add rowFilter only if role matches
    if (hasSalesRoles) {
      obj.rowFilter = {
        $and: [
          {
            createdBy: getUser,
          },
        ],
      };
    }

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalSalesAndRentErfCount(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setSalesAndRentErfStatus(false);
  };

  // SalesBarCodeCount
  const salesBarCodeCount = async () => {
    setSalesBarCodeStatus(true);

    let obj = {
      queryName: "MaterilBarcodeListSL",
      page: 1,
      per_page: 10,
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalSalesBarCodeCount(item?.total);

        // loadOrderCompletedCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setSalesBarCodeStatus(false);
  };

  // RentBarCodeCount
  const rentBarCodeCount = async () => {
    setRentBarCodeStatus(true);

    let obj = {
      queryName: "MaterilBarcodeListRE",
      page: 1,
      per_page: 10,
    };

    await customerItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalRentBarCodeCount(item?.total);

        // loadOrderCompletedCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setRentBarCodeStatus(false);
  };

  // ServiceEnterySheetCount
  const serviceEnterySheetCount = async () => {
    setServiceEnterySheetStatus(true);

    let obj = {};

    await supplierItemService.getSesList(obj).then((item) => {
      if (item?.status === 200) {
        setTotalServiceEnterySheetCount(item?.total);

        // loadOrderCompletedCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setServiceEnterySheetStatus(false);
  };

  // loadCustomerCount
  const loadCustomerCount = async () => {
    setTotalUserCountStatus(true);
    let obj = {
      page: 1,
      per_page: 10,
      queryName: "getSupplier_StatusChartList",
    };

    await supplierItemService.getSupplierList(obj).then((item) => {
      if (item?.status === 200) {
        setTotalUserCount(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalUserCountStatus(false);
  };
  // const loadCustomerCountExtension = async () => {
  //   setTotalUserCountStatus(true);
  //   let obj = {
  //     // page: 1,
  //     // per_page: 10,
  //     // queryName: "getSupplier_StatusChartList",

  //     queryName: "ExtEquipmentList",
  //     page: 1,
  //     per_page: 10,
  //     // "searchTerm": "",
  //     // "timeZone": "Asia/Calcutta"
  //   };
  //   await supplierItemService.generateQuery(obj).then((item) => {
  //     if (item?.status === 200) {
  //       setTotalUserCountExtension(item?.total);
  //     } else {
  //       toast.error(item?.message || "Please try again for Total User Count", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });
  //   setTotalUserCountStatus(false);
  // };

  const loadCustomerCountExtension = async () => {
    setTotalUserCountStatus(true);

    const allowedRoles = ["SALES-PCD", "SALES-OFFICER"];

    const hasSalesRoles = getUserRole?.some((r) =>
      allowedRoles.includes(r.roleId),
    );

    let obj = {
      queryName: "ExtEquipmentList",
      page: 1,
      per_page: 10,
    };

    // 👉 Add rowFilter only if role matches
    if (hasSalesRoles) {
      obj.rowFilter = {
        $and: [
          {
            createdBy: getUser,
          },
        ],
      };
    }

    await supplierItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTotalUserCountExtension(item?.total);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setTotalUserCountStatus(false);
  };
  const suppliersChart = async (filterData) => {
    setSupplierStatusLoading(true);

    let queryName = "";

    switch (filterData.action) {
      case "Yearly":
        queryName = "Yearly_Supplier_Chart_V1";
        break;

      case "Monthly":
        queryName = "Monthly_Supplier_Chart_V1";
        break;

      case "Custom":
        queryName = "Custom_Supplier_Chart_V1";
        break;

      default:
        queryName = "Yearly_Supplier_Chart_V1";
    }

    const mappedFilterData = {
      ...filterData,
      module: "supplier",
      chartType: "bar",
      timeZone: "Asia/Calcutta",
      queryName: queryName,
    };

    try {
      const item = await customerItemService.dashboardV5(mappedFilterData);

      if (item?.status === 200) {
        item.data.module = "supplier";
        setSupplierStatusColChart(item.data);
      } else {
        toast.error(item?.message || "Please try again for Orders");
      }
    } catch (error) {
      toast.error("Error fetching Orders chart data");
    }

    setSupplierStatusLoading(false);
  };

  const loadingAdviceChart = async (filterData) => {
    setLoadingAdviceLoading(true);

    let queryName = "";

    switch (filterData.action) {
      case "Yearly":
        queryName = "Yearly_PO_Chart";
        break;

      case "Monthly":
        queryName = "Monthly_PO_Chart";
        break;

      case "Custom":
        queryName = "Custom_PO_Chart";
        break;

      default:
        queryName = "Yearly_PO_Chart";
    }

    const mappedFilterData = {
      ...filterData,
      module: "po",
      chartType: "bar",
      timeZone: filterData.timeZone || "Asia/Calcutta",
      queryName: queryName,
    };

    try {
      const item = await customerItemService.dashboardV5(mappedFilterData);

      if (item?.status === 200) {
        item.data.module = "po"; // same like supplier
        setLoadingAdviceColChart(item.data);
      } else {
        toast.error(item?.message || "Please try again for Loading Advice");
      }
    } catch (error) {
      toast.error("Error fetching Loading Advice chart data");
    }

    setLoadingAdviceLoading(false);
  };

  const grnChart = async (filterData) => {
    setGrnStatusLoading(true);

    // Map queryName based on action for GRN chart
    const queryMap = {
      Yearly: "Yearly_GRN_Chart",
      Monthly: "Monthly_GRN_Chart",
      Custom: "Custom_GRN_Chart",
    };

    // Create the request payload
    const mappedFilterData = {
      action: filterData.action || "Custom",
      month: filterData.month || "3",
      year: filterData.year || 2026,
      module: "supplier", // Set module for GRN
      chartType: "bar", // or "bar" based on your preference
      timeZone: filterData.timeZone || "Asia/Calcutta",
      fromDate: filterData.fromDate,
      toDate: filterData.toDate,
      queryName: queryMap[filterData.action] || "Custom_GRN_Chart",
    };

    try {
      const item = await customerItemService.dashboardV5(mappedFilterData);

      if (item?.status === 200) {
        item.data.module = "";
        setGrnChartData(item.data);
      } else {
        toast.error(item?.message || "Please try again for GRN Chart");
      }
    } catch (error) {
      toast.error("Error fetching GRN chart data");
    }
    setGrnStatusLoading(false);
  };

  const qualityCheckChart = async (filterData) => {
    setQualityCheckLoading(true);

    const queryMap = {
      Yearly: "Yearly_QualityCheck_Chart",
      Monthly: "Monthly_QualityCheck_Chart",
      Custom: "Custom_QualityCheck_Chart",
    };

    const mappedFilterData = {
      action: filterData.action || "Custom",
      month: filterData.month || "03", //  FIXED: Uncommented
      year: filterData.year || 2026,
      module: "supplier",
      chartType: "bar",
      timeZone: filterData.timeZone || "Asia/Calcutta",
      fromDate: filterData.fromDate,
      toDate: filterData.toDate,
      queryName: queryMap[filterData.action] || "Custom_QualityCheck_Chart",
    };

    try {
      const item = await customerItemService.dashboardV5(mappedFilterData);

      if (item?.status === 200) {
        // Check if data exists and has series with data
        if (item.data && item.data.categories && item.data.series) {
          //  FIX: Just set the data directly
          setQualityCheckChartData(item.data);
        } else {
          setQualityCheckChartData({
            categories: [],
            series: [{ name: "No Data", data: [] }],
          });
        }
      } else {
        toast.error(item?.message || "Please try again");
      }
    } catch (error) {
      console.error("Quality Check Error:", error);
      toast.error("Error fetching Quality Check chart data");
    }
    setQualityCheckLoading(false);
  };

  // ==================== ERF BY STATUS ====================

  const erfStatusChart = async (filterData) => {
    setErfStatusLoading(true);
    const payload = {
      ...filterData,
      module: "erfByStatus",
      chartType: "bar",
      queryName:
        filterData?.action === "Yearly"
          ? "Yearly_ERF_By_Type_Chart"
          : filterData?.action === "Monthly"
            ? "Monthly_ERF_By_Type_Chart"
            : "Custom_ERF_By_Type_Chart",
    };

    try {
      const res = await customerItemService.dashboardV5(payload);
      if (res?.status === 200) setErfStatusData(res.data);
    } catch (error) {
      toast.error("ERF Status error");
    }
    setErfStatusLoading(false);
  };

  const erfExtensionChart = async (filterData) => {
    setErfExtensionLoading(true);

    const payload = {
      ...filterData,
      module: "erfExtensionByType",
      chartType: "bar",
      queryName:
        filterData?.action === "Yearly"
          ? "Yearly_EXT_ERF_By_Type_Chart"
          : filterData?.action === "Monthly"
            ? "Monthly_EXT_ERF_By_Type_Chart"
            : "Custom_EXT_ERF_By_Type_Chart",
    };

    try {
      const res = await customerItemService.dashboardV5(payload);

      if (res?.status === 200) {
        setErfExtensionData(res.data);
      } else {
        toast.error(res?.message || "Extension Chart error");
      }
    } catch (error) {
      toast.error("Extension Chart error");
    }

    setErfExtensionLoading(false);
  };

  const pcdChart = async (filterData) => {
    setPcdLoading(true);

    const payload = {
      ...filterData,
      module: "pcd",
      chartType: "bar",
      queryName:
        filterData?.action === "Yearly"
          ? "Yearly_PCD_ERF_By_Type_Chart"
          : filterData?.action === "Monthly"
            ? "Monthly_PCD_ERF_By_Type_Chart"
            : "Custom_PCD_ERF_By_Type_Chart",
    };

    try {
      const res = await customerItemService.dashboardV5(payload);

      if (res?.status === 200) {
        setPcdData(res.data);
      } else {
        toast.error(res?.message || "Extension Chart error");
      }
    } catch (error) {
      toast.error("Extension Chart error");
    }

    setPcdLoading(false);
  };

  const storeDispatchChart = async (filterData) => {
    setStoreDispatchLoading(true);

    const payload = {
      ...filterData,
      module: "storeDispatch",
      chartType: "bar",
      queryName:
        filterData?.action === "Yearly"
          ? "Yearly_ERF_By_Status_Chart"
          : filterData?.action === "Monthly"
            ? "Monthly_ERF_By_Status_Chart"
            : "Custom_ERF_By_Status_Chart",
    };

    try {
      const res = await customerItemService.dashboardV5(payload);

      if (res?.status === 200) {
        setStoreDispatchData(res.data);
      } else {
        toast.error(res?.message || "Store / Dispatch Chart error");
      }
    } catch (error) {
      toast.error("Store / Dispatch Chart error");
    }

    setStoreDispatchLoading(false);
  };

  // On Filtered Data
  const handleFilterData = async (filter) => {
    await suppliersChart(filter);
    await loadingAdviceChart(filter);
    await grnChart(filter);
    await qualityCheckChart(filter);
    await erfStatusChart(filter);
    await erfExtensionChart(filter);
    await storeDispatchChart(filter);
    await pcdChart(filter);

    // await poChart(filter);
  };

  useEffect(() => {
    if (!isUserDataLoaded) return;

    let defaultFilter = {
      action: "Monthly",
      month: currentMonth,
      year: currentYear,
    };

    loadOrderCount();
    loadCompanyCount();
    loadVendorCount();
    loadErfAssignStoreCount();
    loadDispatchCount();
    servicesPurchaseOrderCount();
    grnCount();
    qualityCheckCount();
    materialCount();
    salesErfCount();
    nursingErfCount();
    serviceErfCount();
    rentErfCount();
    salesAndrentErfCount();
    salesBarCodeCount();
    rentBarCodeCount();
    serviceEnterySheetCount();
    loadCustomerCount();
    loadCustomerCountExtension();
    materialCountStockInStockOut();
    salesandRentStocinStockOut();
    suppliersChart(defaultFilter);
    loadingAdviceChart(defaultFilter);
    qualityCheckChart(defaultFilter);
    erfStatusChart(defaultFilter);
    grnChart(defaultFilter);
    erfExtensionChart(defaultFilter);
    storeDispatchChart(defaultFilter);
    pcdChart(defaultFilter);

    rtdErfCount();
    erfUseCount();
    erfRefundAmountDone();
    erfRefundAmountPending();
    erfTallyStatusDone();
    erfTallyStatusPending();
    erfCreditNotePending();
    erfCreditNoteDone();
    erfFinanceConfiremd();
    erfFinanceNotConfiremd()
    erfPartialEarlyClousr()
    erfEarlyClousr()
    erfClosed()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserDataLoaded]);

  useEffect(() => {
    const userRole = userData?.roles?.[0]?.roleId || null;

    if (userRole === "CUSTOMER") {
      setHideItem(true);
    } else {
      setHideItem(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  const userDataPC = JSON.parse(localStorage.getItem("userData"));
  const allowederfRoles = [
    "SALES-PCD",
    "SALES-OFFICER",
    "SALES-ADMIN",
    "DISPATCH",
    "STORE",
    "PROC-EXECUTIVE",
    "PROC-MNGR",
    "PROC-HEAD",
    "CFO",
    "CEO",
    "MD",
    "FI-MNGR",
    "FI-EXECUTIVE",
    "QUALITYCHECK",
    "SALES-REPORT",
    "SERVICE-EXECUTIVE",
  ];
  const hasErfRoles = userDataPC?.data?.roles?.some((r) =>
    allowederfRoles.includes(r.roleId),
  );

  const allowedAdminRoles = [
    "SALES-ADMIN",
    "PROC-EXECUTIVE",
    "PROC-MNGR",
    "PROC-HEAD",
    "CFO",
    "CEO",
    "MD",
    "FI-MNGR",
    "FI-EXECUTIVE",
  ];
  const hasAdminRoles = userDataPC?.data?.roles?.some((r) =>
    allowedAdminRoles.includes(r.roleId),
  );

  const allowedProcuremnetRoles = [
    "SALES-ADMIN",
    "PROC-EXECUTIVE",
    "PROC-MNGR",
    "PROC-HEAD",
    "CFO",
    "CEO",
    "MD",
    "FI-MNGR",
    "FI-EXECUTIVE",
    "STORE",
    "QUALITYCHECK",
    "DISPATCH",
    "SALES-REPORT",
    "SERVICE-EXECUTIVE",
  ];
  const hasProcuremnetRoles = userDataPC?.data?.roles?.some((r) =>
    allowedProcuremnetRoles.includes(r.roleId),
  );

  useEffect(() => {
    const user = userData?.userId || null;
    const userRole = userData?.roles || null;
    setUser(user);
    setUserRole(userRole);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner timesheet">
            <Row>
              <Col xs={10} md={10}>
                <h2 className="mainTitle">
                  Dashboard -
                  <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                    {getCurrentDate()}
                  </span>
                </h2>
                <p className="subText my-0">Dashboard detailed page</p>
              </Col>
              <Col xs={2} md={2}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />

            <section className="section">
              <div className="row">
                {hasAdminRoles && (
                  <>
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        {/* <div className="card info-card customers-card"> */}
                        <div
                          className="card info-card customers-card "
                          style={{
                            backgroundImage:
                              "linear-gradient(359deg, #d0eeee, #dff5f5, #cdefef)",
                          }}
                        >
                          <div className="card-body">
                            <h5 className="card-title">
                              Company
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i className="bi bi-people"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalCompanyCountStatus}
                                />
                                <h6>
                                  {!totalCompanyCountStatus
                                    ? formatToTwoDigits(totalCompanyCount || 0)
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage("totalCompanyCount")
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        {/* <div className="card info-card customers-card"> */}
                        <div
                          className="card info-card customers-card "
                          style={{
                            backgroundImage:
                              "linear-gradient(359deg, #d0eeee, #dff5f5, #cdefef)",
                          }}
                        >
                          <div className="card-body">
                            <h5 className="card-title">
                              Supplier/Vendor
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i className="bi bi-people"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall isLoading={totalUserCountStatus} />
                                <h6>
                                  {!totalUserCountStatus
                                    ? formatToTwoDigits(totalUserCount || 0)
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage("totalSupplierCount")
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        {/* <div className="card info-card customers-card"> */}
                        <div
                          className="card info-card customers-card "
                          style={{
                            backgroundImage:
                              "linear-gradient(359deg, #d0eeee, #dff5f5, #cdefef)",
                          }}
                        >
                          <div className="card-body">
                            <h5 className="card-title">
                              Hospital/Patient/Nurse/Doctor
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i className="bi bi-people"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalVendorCountStatus}
                                />
                                <h6>
                                  {!totalVendorCountStatus
                                    ? formatToTwoDigits(totalVendorCount || 0)
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage("mrUserList")
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        {/* <div className="card info-card customers-card"> */}
                        <div
                          className="card info-card customers-card "
                          style={{
                            backgroundImage:
                              "linear-gradient(359deg, #d0eeee, #dff5f5, #cdefef)",
                          }}
                        >
                          <div className="card-body">
                            <h5 className="card-title">
                              Products/Material Master
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-layers"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall isLoading={getMaterialStatus} />
                                <h6>
                                  {!getMaterialStatus
                                    ? formatToTwoDigits(
                                        getTotalMaterialCount || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() => navigateToMainPage("material")}
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <Row>
                      <Col className="fw-bold fs-3 text-dark commTopButtonRightLeftPadding">
                        Product/Stock
                        <hr />
                      </Col>
                    </Row>

                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Sales Barcode
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-upc"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={getSalesBarCodeStatus}
                                />
                                <h6>
                                  {!getSalesBarCodeStatus
                                    ? formatToTwoDigits(
                                        getTotalSalesBarCodeCount || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage("salesBarcodeList")
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Rent Barcode
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-upc"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall isLoading={getRentBarCodeStatus} />
                                <h6>
                                  {!getRentBarCodeStatus
                                    ? formatToTwoDigits(
                                        getTotalRentBarCodeCount || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage("rentBarcodeList")
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Stock In Products
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-layers"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall isLoading={getMaterialStatus} />
                                <h6>
                                  {!getMaterialStatus
                                    ? formatToTwoDigits(stockInCount || 0)
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() => navigateToMainPage("material")}
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Stock Out Products
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-layers"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall isLoading={getMaterialStatus} />
                                <h6>
                                  {!getMaterialStatus
                                    ? formatToTwoDigits(stockOutCount || 0)
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() => navigateToMainPage("material")}
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Sales Stock In Products
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-layers"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall isLoading={getMaterialStatus} />
                                <h6>
                                  {!getMaterialStatus
                                    ? formatToTwoDigits(salesStockIn || 0)
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage("salesStockIn")
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Sales Stock Out Products
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-layers"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall isLoading={getMaterialStatus} />
                                <h6>
                                  {!getMaterialStatus
                                    ? formatToTwoDigits(salesStockOut || 0)
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage("salesStockIn")
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Rent Stock In Products
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-layers"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall isLoading={getMaterialStatus} />
                                <h6>
                                  {!getMaterialStatus
                                    ? formatToTwoDigits(rentStockIn || 0)
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage("rentBarcodeList")
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Rent Stock Out Products
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-layers"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall isLoading={getMaterialStatus} />
                                <h6>
                                  {!getMaterialStatus
                                    ? formatToTwoDigits(rentStockOut || 0)
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage("rentBarcodeList")
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {hasProcuremnetRoles && (
                  <>
                    <Row>
                      <Col className="fw-bold fs-3 text-dark commTopButtonRightLeftPadding">
                        Procurement
                        <hr />
                      </Col>
                    </Row>

                    <div className="col-lg-3 commTopButtonRightLeftPadding">
                      <div
                        className="card info-card sales-card "
                        style={{
                          backgroundImage:
                            "linear-gradient(359deg, #d0eeee, #dff5f5, #cdefef)",
                        }}
                      >
                        {/* <div className="card info-card sales-card"> */}
                        <div className="card-body">
                          <h5 className="card-title">
                            Material Purchase Orders
                            {/* <span>| Today</span> */}
                          </h5>

                          <div className="d-flex align-items-center">
                            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                              <i class="bi bi-box-seam"></i>
                            </div>
                            <div className="ps-3">
                              <LoaderSmall isLoading={totalOrderCountStatus} />
                              <h6>
                                {!totalOrderCountStatus
                                  ? formatToTwoDigits(totalOrderCount || 0)
                                  : ""}
                              </h6>
                              <span className="text-muted small pt-2 ps-1">
                                Total Count
                              </span>
                              <span
                                className="text-muted small pt-2 ps-1"
                                onClick={() =>
                                  navigateToMainPage("totalOrderCount")
                                }
                              >
                                <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 commTopButtonRightLeftPadding">
                      {/* <div className="card info-card sales-card"> */}
                      <div
                        className="card info-card sales-card "
                        style={{
                          backgroundImage:
                            "linear-gradient(359deg, #d0eeee, #dff5f5, #cdefef)",
                        }}
                      >
                        <div className="card-body">
                          <h5 className="card-title">
                            Service Purchase Orders
                            {/* <span>| Today</span> */}
                          </h5>

                          <div className="d-flex align-items-center">
                            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                              <i class="bi bi-tools"></i>
                            </div>
                            <div className="ps-3">
                              <LoaderSmall
                                isLoading={getTotalServicesPurchaseOrderStatus}
                              />
                              <h6>
                                {!getTotalServicesPurchaseOrderStatus
                                  ? formatToTwoDigits(
                                      getTotalServicesPurchaseOrderCount || 0,
                                    )
                                  : ""}
                              </h6>
                              <span className="text-muted small pt-2 ps-1">
                                Total Count
                              </span>
                              <span
                                className="text-muted small pt-2 ps-1"
                                onClick={() =>
                                  navigateToMainPage(
                                    "totalServicePurchaseOrderCount",
                                  )
                                }
                              >
                                <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        {/* <div className="card info-card customers-card"> */}
                        <div
                          className="card info-card customers-card "
                          style={{
                            backgroundImage:
                              "linear-gradient(359deg, #d0eeee, #dff5f5, #cdefef)",
                          }}
                        >
                          <div className="card-body">
                            <h5 className="card-title">Goods Receipt</h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i className="bi bi-truck"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall isLoading={getGrnStatus} />
                                <h6>
                                  {!getGrnStatus
                                    ? formatToTwoDigits(getTotalGrnCount || 0)
                                    : ""}
                                </h6>

                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() => navigateToMainPage("grnList")}
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        {/* <div className="card info-card revenue-card"> */}
                        <div
                          className="card info-card revenue-card "
                          style={{
                            backgroundImage:
                              "linear-gradient(359deg, #d0eeee, #dff5f5, #cdefef)",
                          }}
                        >
                          <div className="card-body">
                            <h5 className="card-title">Quality Check</h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-patch-check"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={getQualityCheckStatus}
                                />
                                <h6>
                                  {!getQualityCheckStatus
                                    ? formatToTwoDigits(
                                        getTotalQualityCheckCount || 0,
                                      )
                                    : ""}
                                </h6>

                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage("qualityCheckList")
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        {/* <div className="card info-card revenue-card"> */}
                        <div
                          className="card info-card revenue-card "
                          style={{
                            backgroundImage:
                              "linear-gradient(359deg, #d0eeee, #dff5f5, #cdefef)",
                          }}
                        >
                          <div className="card-body">
                            <h5 className="card-title">Service Entery Sheet</h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-file-earmark-text"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={getServiceEnterySheetStatus}
                                />
                                <h6>
                                  {!getServiceEnterySheetStatus
                                    ? formatToTwoDigits(
                                        getTotalServiceEnterySheetCount || 0,
                                      )
                                    : ""}
                                </h6>

                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage("serviceEneryList")
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {hasErfRoles && (
                  <>
                    <Row>
                      <Col className="fw-bold fs-3 text-dark commTopButtonRightLeftPadding">
                        ERF
                        <hr />
                      </Col>
                    </Row>

                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Sales ERF
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-file-earmark-text"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall isLoading={getSalesErfStatus} />
                                <h6>
                                  {!getSalesErfStatus
                                    ? formatToTwoDigits(
                                        getTotalSalesErfCount || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() => navigateToMainPage("erfList")}
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Rent ERF
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-file-earmark-text"></i>
                              </div>
                              <div className="ps-3">
                                <LoaderSmall isLoading={getRentErfStatus} />
                                <h6>
                                  {!getRentErfStatus
                                    ? formatToTwoDigits(
                                        getTotalRentErfCount || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() => navigateToMainPage("erfList")}
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Sales and Rent ERF
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-card-checklist"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={getSalesAndRentErfStatus}
                                />
                                <h6>
                                  {!getSalesAndRentErfStatus
                                    ? formatToTwoDigits(
                                        getTotalSalesAndRentErfCount || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage("salseAndRentErfList")
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Service ERF
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-card-checklist"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall isLoading={getServiceErfStatus} />
                                <h6>
                                  {!getServiceErfStatus
                                    ? formatToTwoDigits(
                                        getTotalServiceErfCount || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() => navigateToMainPage("erfList")}
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Nursing ERF
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-card-checklist"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall isLoading={getNursingErfStatus} />
                                <h6>
                                  {!getNursingErfStatus
                                    ? formatToTwoDigits(
                                        getTotalNursingErfCount || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() => navigateToMainPage("erfList")}
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Assigned To Store ERF
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-card-checklist"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalErfAssignStoreStatus}
                                />
                                <h6>
                                  {!totalErfAssignStoreStatus
                                    ? formatToTwoDigits(
                                        totalErfAssignStoreCount || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage(
                                      "totalErfAssignStoreCount",
                                    )
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Dispatched ERF
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-card-checklist"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall isLoading={totalDispatchStatus} />
                                <h6>
                                  {!totalDispatchStatus
                                    ? formatToTwoDigits(totalDispatchCount || 0)
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage("dispatchList")
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Ready to Dispatch
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-card-checklist"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalRTDERFCountStatus}
                                />
                                <h6>
                                  {!totalRTDERFCountStatus
                                    ? formatToTwoDigits(totalRTDERFCount || 0)
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage("erfReadytoDispatch")
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Under Service Executive
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-card-checklist"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalErfUseCountStatus}
                                />
                                <h6>
                                  {!totalErfUseCountStatus
                                    ? formatToTwoDigits(totalErfUseCount || 0)
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage(
                                      "erfUnderServiceExecutive",
                                    )
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {/* reund amout - done */}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Refund Amount Done
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-card-checklist"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalErRefundAmountStatus}
                                />
                                <h6>
                                  {!totalErRefundAmountStatus
                                    ? formatToTwoDigits(
                                        totalErRefundAmount || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateWithFilters([
                                      {
                                        refundAmountIndicator: false,
                                      },
                                     
                                    ])
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">
                              Refund Amount Pending
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-card-checklist"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalErRefundAmountStatusPending}
                                />
                                <h6>
                                  {!totalErRefundAmountStatusPending
                                    ? formatToTwoDigits(
                                        totalErRefundAmountPending || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateWithFilters([
                                      {
                                        refundAmountIndicator: true,
                                      },
                                      {
                                        refundAmountIndicator: true,
                                      },
                                    ])
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">Tally Status Done</h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-card-checklist"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalErfTallyStatusDoneStatus}
                                />
                                <h6>
                                  {!totalErfTallyStatusDoneStatus
                                    ? formatToTwoDigits(
                                        totalErfTallyStatusDone || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateWithFilters([
                                      {
                                        tallyStatusIndicator: {
                                          $regex: ".*Done.*",
                                          $options: "i",
                                        },
                                      },
                                      {
                                        tallyStatusIndicator: {
                                          $regex: ".*Done.*",
                                          $options: "i",
                                        },
                                      },
                                    ])
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">Tally Status Pending</h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-card-checklist"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalErfTallyStatusPendingStatus}
                                />
                                <h6>
                                  {!totalErfTallyStatusPendingStatus
                                    ? formatToTwoDigits(
                                        totalErfTallyStatusPending || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateWithFilters([
                                      {
                                        tallyStatusIndicator: {
                                          $regex: ".*Pending.*",
                                          $options: "i",
                                        },
                                      },
                                    ])
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">Credit Note Done</h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-card-checklist"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalErfCreditNoteDoneStatus}
                                />
                                <h6>
                                  {!totalErfCreditNoteDoneStatus
                                    ? formatToTwoDigits(
                                        totalErfCreditNoteDone || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateWithFilters([

                                      {
                                        creditNoteIndicator: false,
                                      },
                                    ])
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">Credit Note Pending</h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-card-checklist"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalErfCreditNotePendingStatus}
                                />
                                <h6>
                                  {!totalErfCreditNotePendingStatus
                                    ? formatToTwoDigits(
                                        totalErfCreditNotePending || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateWithFilters([
                                      {
                                        creditNoteIndicator: true,
                                      },
                                    ])
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">Finance Confirmed</h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-card-checklist"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalErFinanceConfirmedStatus}
                                />
                                <h6>
                                  {!totalErFinanceConfirmedStatus
                                    ? formatToTwoDigits(
                                        totalErFinanceConfirmed || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateWithFilters([
                                      {
                                        financeCollectionConfirmation: {
                                          $regex: ".*Confirmed.*",
                                          $options: "i",
                                        },
                                      },
                                    ])
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                   
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">Finance Not Confirmed</h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-card-checklist"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalErfFinanceNotConfirmedStatus}
                                />
                                <h6>
                                  {!totalErfFinanceNotConfirmedStatus
                                    ? formatToTwoDigits(
                                        totalErfFinanceNotConfirmed || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateWithFilters([
                                      {
                                        financeCollectionConfirmation: {
                                          $regex: ".*Not Confirmed.*",
                                          $options: "i",
                                        },
                                      },
                                    ])
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">Partial Early Closure</h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-card-checklist"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalErPartialEarlyClosurStatus}
                                />
                                <h6>
                                  {!totalErPartialEarlyClosurStatus
                                    ? formatToTwoDigits(
                                        totalErPartialEarlyClosur || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateWithFilters([

                                      {
                                        pcCallStatus: {
                                          $regex: ".*Partial Early Closur.*",
                                          $options: "i",
                                        },
                                      },
                                    ])
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">Early Closure</h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-card-checklist"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalErEarlyClosurStatus}
                                />
                                <h6>
                                  {!totalErEarlyClosurStatus
                                    ? formatToTwoDigits(
                                        totalErEarlyClosur || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateWithFilters([

                                      {
                                        pcCallStatus: {
                                          $regex: ".*Early Closure.*",
                                          $options: "i",
                                        },
                                      },
                                    ])
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div className="card info-card customers-card">
                          <div className="card-body">
                            <h5 className="card-title">Closed</h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-card-checklist"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall
                                  isLoading={totalErClosedStatus}
                                />
                                <h6>
                                  {!totalErClosedStatus
                                    ? formatToTwoDigits(
                                        totalErClosed || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateWithFilters([

                                      {
                                        pcCallStatus: {
                                          $regex: ".*Closed",
                                          $options: "i",
                                        },
                                      },
                                    ])
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <Row>
                      <Col className="fw-bold fs-3 text-dark commTopButtonRightLeftPadding">
                        PCD
                        <hr />
                      </Col>
                    </Row>

                    {!hideItem && (
                      <div className="col-lg-3 commTopButtonRightLeftPadding">
                        <div
                          className="card info-card customers-card"
                          style={{
                            backgroundImage:
                              "linear-gradient(359deg, #d0eeee, #dff5f5, #cdefef)",
                          }}
                        >
                          <div className="card-body">
                            <h5 className="card-title">
                              Extended ERF
                              {/* <span>| This Year</span> */}
                            </h5>

                            <div className="d-flex align-items-center">
                              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                <i class="bi bi-card-checklist"></i>{" "}
                              </div>
                              <div className="ps-3">
                                <LoaderSmall isLoading={totalUserCountStatus} />
                                <h6>
                                  {!totalUserCountStatus
                                    ? formatToTwoDigits(
                                        totalUserCountExtension || 0,
                                      )
                                    : ""}
                                </h6>
                                <span className="text-muted small pt-2 ps-1">
                                  Total Count
                                </span>
                                <span
                                  className="text-muted small pt-2 ps-1"
                                  onClick={() =>
                                    navigateToMainPage("extendedErfList")
                                  }
                                >
                                  <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
              {filterShow && (
                <DatePickerComponent
                  getfiltereddata={handleFilterData}
                  cancelAction={() => setFilterShow(!filterShow)}
                />
              )}
              <div className="row">
                {/* Supplier/Vendor */}
                {hasAdminRoles && (
                  <>
                    <div className="col-lg-12 commTopButtonRightLeftPadding">
                      <div className="card">
                        <div className="card-body">
                          <h5 className="card-title">Supplier/Vendor</h5>

                          {/* <div id="columnChart"></div> */}
                          <LoaderSmall isLoading={supplierStatusLoading} />
                          <h6>
                            {!supplierStatusLoading ? (
                              <OrdersColumnChart
                                key="supplier"
                                chartdata={supplierStatusColChart}
                              />
                            ) : (
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {hasProcuremnetRoles && (
                  <>
                    {" "}
                    {/* Purchase Order */}
                    <div className="col-lg-12 commTopButtonRightLeftPadding">
                      <div className="card">
                        <div className="card-body">
                          <h5 className="card-title">Purchase Order</h5>

                          {/* <div id="columnChart"></div> */}
                          <LoaderSmall isLoading={loadingAdviceLoading} />
                          <h6>
                            {!loadingAdviceLoading ? (
                              <OrdersColumnChart
                                key="PO"
                                chartdata={loadingAdviceColChart}
                              />
                            ) : (
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                    {/* Goods Receipt */}
                    <div className="col-lg-12 commTopButtonRightLeftPadding">
                      <div className="card">
                        <div className="card-body">
                          <h5 className="card-title">Goods Receipt</h5>

                          {/* <div id="columnChart"></div> */}
                          <LoaderSmall isLoading={grnStatusLoading} />
                          <h6>
                            {!grnStatusLoading ? (
                              <OrdersColumnChart
                                key="grn"
                                chartdata={grnchartData}
                              />
                            ) : (
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                    {/* Quality Check */}
                    <div className="col-lg-12 commTopButtonRightLeftPadding">
                      <div className="card">
                        <div className="card-body">
                          <h5 className="card-title">Quality Check</h5>

                          {/* <div id="columnChart"></div> */}
                          <LoaderSmall isLoading={qualityCheckLoading} />
                          <h6>
                            {!qualityCheckLoading ? (
                              <OrdersColumnChart
                                key="qualityCheck"
                                chartdata={qualityCheckChartData}
                              />
                            ) : (
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {hasErfRoles && (
                  <>
                    {/* ERF(Equipment Rent Form) */}
                    <div className="col-lg-12 commTopButtonRightLeftPadding">
                      <div className="card">
                        <div className="card-body">
                          <h5 className="card-title">
                            ERF(Equipment Rent Form)
                          </h5>

                          {/* <div id="columnChart"></div> */}
                          <LoaderSmall isLoading={erfStatusLoading} />
                          <h6>
                            {!erfStatusLoading ? (
                              <OrdersColumnChart
                                key="erfStatus"
                                chartdata={erfStatusData}
                              />
                            ) : (
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                    {/* Team - Store/Dispatch/Service Executive */}
                    <div className="col-lg-12 commTopButtonRightLeftPadding">
                      <div className="card">
                        <div className="card-body">
                          <h5 className="card-title">
                            Team - Store/Dispatch/Service Executive{" "}
                          </h5>

                          {/* <div id="columnChart"></div> */}
                          <LoaderSmall isLoading={storeDispatchLoading} />
                          <h6>
                            {!storeDispatchLoading ? (
                              <OrdersColumnChart
                                key="storeDispatch"
                                chartdata={storeDispatchData}
                              />
                            ) : (
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                    {/* ERF Extensions */}
                    <div className="col-lg-12 commTopButtonRightLeftPadding">
                      <div className="card">
                        <div className="card-body">
                          <h5 className="card-title">ERF Extensions</h5>

                          {/* <div id="columnChart"></div> */}
                          <LoaderSmall isLoading={erfExtensionLoading} />
                          <h6>
                            {!erfExtensionLoading ? (
                              <OrdersColumnChart
                                key="erfExtension"
                                chartdata={erfExtensionData}
                              />
                            ) : (
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                    {/* Patient Counseling Department */}
                    <div className="col-lg-12 commTopButtonRightLeftPadding">
                      <div className="card">
                        <div className="card-body">
                          <h5 className="card-title">
                            Patient Counseling Department
                          </h5>

                          {/* <div id="columnChart"></div> */}
                          <LoaderSmall isLoading={pcdLoading} />
                          <h6>
                            {!pcdLoading ? (
                              <OrdersColumnChart
                                key="pcd"
                                chartdata={pcdData}
                              />
                            ) : (
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {/* Sales Team */}
                <div className="col-lg-6 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Sales Team</h5>

                      <div id="pieChart"></div>
                      <PieChart />
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">PCD Team</h5>

                      <div id="donutChart"></div>
                      <DonutChart />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default CustomerV5Dashboard;
